module.exports = __webpack_public_path__ + "static/media/Phase-2-Operations-Procedures.611be1db.pdf";